import { useRoute } from '@/hooks/useRoute';
import { SitesList } from './SitesList';
import { SiteDetail } from './SiteDetail';

export function SiteScreen() {
  const route = useRoute();
  return route.siteId ? <SiteDetail siteId={route.siteId} /> : <SitesList />;
}
